import { render, staticRenderFns } from "./chongyangheying.vue?vue&type=template&id=b405542c&scoped=true&"
import script from "./chongyangheying.vue?vue&type=script&lang=js&"
export * from "./chongyangheying.vue?vue&type=script&lang=js&"
import style0 from "./chongyangheying.vue?vue&type=style&index=0&id=b405542c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b405542c",
  null
  
)

export default component.exports